const imgData_2026 = {
  weird_west: {
    title: 'Weird West',
    imgs: {
      full: {
        src: require('./weird_west_2026_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./weird_west_2026_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen, markers, coloured pencils and watercolour on paper. 420 x 597 mm, 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'My first Weird West / Deadlands commission for a team of players to surprise one of them for his birthday. It was realy cool to immerse into this world and do something different than my usual high fantasy theme. I think it\'s just the thing with western, anything you build around it will be cool. And what can go wrong when you add some monsters to kill in that setting?',
  },
  dacian_dragon_tattoo: {
    title: 'Dacian Dragon Tattoo',
    imgs: {
      full: {
        src: require('./dacian_dragon_tattoo_2026_web.jpg'),
        width: 1060,
        height: 1500,
      },
      thumb: {
        src: require('./dacian_dragon_tattoo_2026_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen on paper. 210 x 297 mm, 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'Another tattoo design commission, this time with clear, simple lines, in honour of parental ancestry.',
  },
  the_dream_of_zarathustra: {
    title: 'The Dream of Zarathustra',
    imgs: {
      full: {
        src: require('./the_dream_of_zarathustra_2026_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./the_dream_of_zarathustra_2026_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen and watercolour on paper. 18 x 24", 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'My largest D&D commission to date. This poster-like painting was requested as a present to the dungeon master and showcases iconic items from the campaign along with the characters.<br /><br />I love drawing D&D characters, they always have a rich backstory that makes the drawing of each character exciting but challenging at the same time. Figuring out a composition that works with so much going on was another challenge, but I had  a lot of set guidelines and asks that set the direction (eg the "framed" concept or the calligraphic title) , ',
  },
  girl_in_a_purple_dress: {
    title: 'Girl in a Purple Dress',
    imgs: {
      full: {
        src: require('./girl_in_a_purple_dress_2026_web.jpg'),
        width: 1200,
        height: 1500,
      },
      thumb: {
        src: require('./girl_in_a_purple_dress_2026_thumb.jpg'),
        width: 480,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen and watercolour on paper. 8 x 10", 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'This commission was made as a gift with a special request: I had to leave a blank box at the bottom where I could sign the picture, as this was gifted to a boy with special needs. He only accepts signatures on paintings if the signature is not in the image. In fairness, can\'t blame him! I always have a hard time deciding where to sign my paintings as I feel like it\'s in the way everywhere, at least this time this wasn\'t a problem.',
  },
  lorreh_soba_and_the_turtle: {
    title: 'Lorreh Soba and the Turtle',
    imgs: {
      full: {
        src: require('./lorreh_soba_and_the_turtle_2026_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./lorreh_soba_and_the_turtle_2026_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen, markers, coloured pencils and watercolour on paper. 210 x 297 mm, 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'Another Star Wars commission (I made a tattoo design a couple of years ago) but this time it is both a character design art and a story illustration.<br /><br />Lorreh Soba is a 4 year old Jedi student, and one day she got the task to follow and guard the old turtle of the gardens. The old guy couldn\'t reach the juiciest leaves though, but fortunately Lorreh was there to help him with the Force.',
  },
  the_changewing_nest: {
    title: 'The Changewing Nest',
    imgs: {
      full: {
        src: require('./the_changewing_nest_2026_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./the_changewing_nest_2026_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen and watercolour on paper. 12 x 16", 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'A How To Train Your Dragon themed commission picturing a Changewing nest with a mom guarding an egg, and a young fledgling exploring his colour changing skills.<br /><br />In this picture I used a different technique for the outlines (which since then became my standard). Black outlines are only used for figures in the foreground, and I use different grey shades for figures strongly lit or fading into the background. This gave the picture a more atmospheric look.',
  },
  armor_king: {
    title: 'Armor King',
    imgs: {
      full: {
        src: require('./armor_king_2026_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./armor_king_2026_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2026',
    description: 'Pen and watercolour on paper. 12 x 16", 2026.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story: 'Absolutely love it when I get commission requests like this: paint Armor King but in a Warhammer 40k Dark Angel style. I don\'t think any other commentary is needed.',
  },
};

export default imgData_2026;
